export const environment = {
    production: true,

  // mapping for production 
    // firebaseConfig: {
    //     apiKey: "AIzaSyC4Fwd5Kg343HREFXJV21AncYfYFuL3iWI",
    //     authDomain: "blockcurr-transaction.firebaseapp.com",
    //     databaseURL: "https://blockcurr-transaction.firebaseio.com",
    //     projectId: "blockcurr-transaction",
    //     storageBucket: "blockcurr-transaction.firebasestorage.app",
    //     messagingSenderId: "67620459424",
    //     appId: "1:67620459424:web:8be8efbaabce60e5038ac5"
    // },

// mapping for UAT

 firebaseConfig : {
    apiKey: "AIzaSyCVtGqwJ-RpimCnW1O10v45CobOi3UcBx4",
    authDomain: "blockcurr-transaction-uat.firebaseapp.com",
    databaseURL: "https://blockcurr-transaction-uat-default-rtdb.firebaseio.com",
    projectId: "blockcurr-transaction-uat",
    storageBucket: "blockcurr-transaction-uat.firebasestorage.app",
    messagingSenderId: "34726,059506",
    appId: "1:34726059506:web:43b0b952f726408dabdf6b",
    measurementId: "G-W12GW59DJZ"
  },

    aureuscoinservice:'https://blockcurrxchange-uat-dot-blockcurrxchangeservice.uc.r.appspot.com/'

};
